<template>
  <div class="footer d-flex justify-content-end">
    <p>Copyright © Peakview Operating Company LLC, 2015</p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p{
  color: black;
  padding-right: 1rem;
}
.footer{
  background-color: #C19A35;
  padding: 0px;
  height: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue